jQuery(document).ready(function () {
  jQuery(window).on("scroll", function () {
    if (jQuery(window).scrollTop() > 0) {
      jQuery(".header-container .logo").addClass("scrolled");
    } else {
      jQuery(".header-container .logo").removeClass("scrolled");
    }
  });
 });


 // Add scrolled class to nav bar logo so that we can cause it to move up on scroll
